<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle" ref="header"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr pt25 mb25">
          <div class="formArea mt0">
            <select class="ipt" title="선납금액확인 선택" v-model="summaryIdx" @change="changeOrderId">
              <option value="99" selected="selected">상품을 선택해주세요</option>
              <!--<template v-for="(orderAuthBillSummary, key) in orderAuthBillSummaryList">-->
              <!--<option :value="key" v-bind:key="key" v-if="orderAuthBillSummary.restRentalPeriod > 11">-->
              <!--{{ orderAuthBillSummary.orderId }} / {{ orderAuthBillSummary.productName }}-->
              <!--</option>-->
              <!--</template>-->
              <option v-for="(orderAuthBillSummary, key) in orderAuthBillSummaryList" :value="key" :key="key">
                {{ orderAuthBillSummary.orderId }} / {{ orderAuthBillSummary.productName }}
              </option>
            </select>
            <div class="ar">
              <span class="txtXS">
                렌탈료 선납
                <div class="toolTip">
                  <em class="tit">렌탈료 선납이란?</em>
                  렌탈기간내 일부 상환조건으로 선납년수에 따라 할인적용됩니다.
                </div>
              </span>
            </div>
          </div>
          <div class="orderSum bgNone pd0 mt20">
            <ul class="infoList">
              <li>
                <span class="item">월렌탈료</span>
                <span class="val">{{ payAmounts | currency }}원</span>
              </li>
              <li>
                <span class="item">잔여회차</span>
                <span class="val">{{ restRentalPeriod | currency }}회</span>
              </li>
            </ul>
          </div>
        </section>
        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">선납렌탈 기간 선택</h2>
          </div>

          <div class="tabWrap prePayTab">
            <ul class="prePayTabList iptBtn">
              <li @click="choiceYear(0)" :class="{ on: this.tabYear === 0 }" v-if="tabYear0" style="width: 33%">
                <span class="ico">
                  1년
                  <span class="txtXS">(6%할인)</span>
                </span>
              </li>
              <li @click="choiceYear(1)" :class="{ on: this.tabYear === 1 }" v-if="tabYear1" style="width: 33%">
                <span class="ico">
                  2년
                  <span class="txtXS">(8%할인)</span>
                </span>
              </li>
              <li @click="choiceYear(2)" :class="{ on: this.tabYear === 2 }" v-if="tabYear2" style="width: 33%">
                <span class="ico">
                  3년
                  <span class="txtXS">(10%할인)</span>
                </span>
              </li>
            </ul>
            <div class="titArea">
              <h2 class="txtXS pointC7">선납금액확인</h2>
            </div>
            <div class="tabContents">
              <div class="tabPanel" style="display: block" v-if="showTabPanel">
                <div class="orderSum">
                  <ul class="infoList">
                    <li>
                      <span class="item">선납 렌탈 기간</span>
                      <span class="val txtXS">
                        {{ startDate }} ~ {{ endDate }}
                        <br />
                        ({{ startSeq }}~{{ endSeq }}회차)
                      </span>
                    </li>
                    <li v-if="paymentRemained">
                      <span class="item">재납부 예정일</span>
                      <span class="val">
                        {{ reEndDate }}
                        <br />
                        ({{ reEndSeq }}회차부터)
                      </span>
                    </li>
                    <li>
                      <span class="item">선납렌탈료</span>
                      <span class="val">{{ prePayAmounts | currency }}원</span>
                    </li>
                    <li>
                      <span class="item pointC1">선납할인({{ prePaySale }}%)</span>
                      <span class="val pointC1">- {{ prePaySaleAmounts | currency }}원</span>
                    </li>
                    <li class="total">
                      <span class="item">
                        <em>총 결제 예상금액</em>
                      </span>
                      <span class="val">
                        <span class="money">
                          <em>{{ exAmounts | currency }}</em>
                          원
                        </span>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="titArea">
            <h2 class="txtXS pointC7 fl">잔여 렌탈료</h2>
            <a href="javascript:void(0);" class="fr txtXS tit link" @click="showVirtualSchedule">가상 스케줄</a>
          </div>

          <div class="orderSum">
            <ul class="infoList">
              <li>
                <span class="item">월렌탈료</span>
                <span class="val">{{ payAmounts | currency }}원</span>
              </li>
              <li>
                <span class="item">잔여회차</span>
                <span class="val">{{ remainingSeq | currency }}회</span>
              </li>
            </ul>
          </div>
        </section>

        <section class="hr">
          <span class="label mt0 txtM bold">카드정보 입력</span>

          <div class="formArea mt20">
            <span class="label mt20">카드선택</span>
            <select v-on:input="changeCard($event.target.value)" v-model="cardName" name="card" class="ipt" title="카드선택">
              <option value="" disabled="disabled" selected="selected">선택해주세요</option>
              <option v-for="(card, index) in rcadCodeList" :value="card.code" :key="index">{{ card.codeName }}</option>
            </select>

            <span class="label">카드번호</span>
            <div class="transkey">
              <div class="setCard">
                <input
                  type="tel"
                  id="cardNum1"
                  class="ipt"
                  maxlength="4"
                  title="카드번호 첫번째 4자리"
                  value=""
                  v-model="cardNum1"
                  nextTarget="cardNum2"
                  v-onlyNum
                  v-skipOfMax
                />
                <span class="sign" aria-hidden="true">-</span>
                <input
                  type="tel"
                  id="cardNum2"
                  class="ipt"
                  maxlength="4"
                  title="카드번호 두번째 4자리"
                  value=""
                  v-model="cardNum2"
                  nextTarget="cardNum3"
                  v-onlyNum
                  v-skipOfMax
                />
                <span class="sign" aria-hidden="true">-</span>
                <input
                  type="tel"
                  class="ipt"
                  maxlength="4"
                  id="cardNum3"
                  nextTarget="cardNum4"
                  title="카드번호 세번째 4자리"
                  v-onlyNum
                  v-skipOfMax
                  value=""
                  data-tk-kbdType="number"
                  onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                />
                <span class="sign" aria-hidden="true">-</span>
                <input
                  type="tel"
                  class="ipt"
                  maxlength="4"
                  id="cardNum4"
                  title="카드번호 마지막 4자리"
                  v-onlyNum
                  value=""
                  data-tk-kbdType="number"
                  onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                />
              </div>
            </div>

            <span class="label">유효기간</span>
            <div class="transkey">
              <div class="setPeriod">
                <input
                  type="tel"
                  class="ipt"
                  maxlength="2"
                  id="expirdateMM"
                  nextTarget="expirdateYY"
                  title="유효기간 월 2자리"
                  placeholder="MM"
                  v-onlyNum
                  v-skipOfMax
                  data-tk-kbdType="number"
                  onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                />
                <span class="sign" aria-hidden="true">/</span>
                <input
                  type="tel"
                  class="ipt"
                  maxlength="2"
                  id="expirdateYY"
                  title="유효기간 년 2자리"
                  placeholder="YY"
                  v-onlyNum
                  data-tk-kbdType="number"
                  onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                />
              </div>
            </div>

            <span class="label">비밀번호</span>
            <div class="transkey">
              <div class="setPw">
                <input
                  type="password"
                  class="ipt"
                  id="password"
                  maxlength="2"
                  title="비밀번호 앞 2자리"
                  placeholder="앞 2자리"
                  v-onlyNum
                  data-tk-kbdType="number"
                  onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                />
                <input type="password" class="ipt" maxlength="2" title="비밀번호 뒤 2자리" value="**" readonly="readonly" />
              </div>
            </div>

            <span class="label">생년월일</span>
            <div class="setBirth">
              <input
                type="tel"
                id="ssn1"
                class="ipt"
                maxlength="4"
                title="생년월일 년도 4자리"
                placeholder="1990"
                v-model="ssn1"
                nextTarget="ssn2"
                v-onlyNum
                v-skipOfMax
              />
              <span class="sign" aria-hidden="true">/</span>
              <input
                type="tel"
                id="ssn2"
                class="ipt"
                maxlength="2"
                title="생년월일 월 2자리"
                placeholder="01"
                v-model="ssn2"
                nextTarget="ssn3"
                v-onlyNum
                v-skipOfMax
              />
              <span class="sign" aria-hidden="true">/</span>
              <input type="tel" id="ssn3" class="ipt" maxlength="2" title="생년월일 일 2자리" placeholder="01" v-model="ssn3" v-onlyNum />
            </div>

            <p class="txtList_remark">
              선납 결제건에 대한 청구금액 상세항목 및 결제내역 반영에는 전산 적용으로 인해 소정의 시간차가 있을 수 있습니다.
            </p>

            <span class="singleIpt mt20">
              <input type="checkbox" class="ipt" id="chk2" />
              <label class="normal" for="chk2">
                <span>
                  결제할 항목의 금액정보를 확인했으며 이에 동의합니다.
                  <br />
                  (전자상거래법 제8조2항)
                </span>
              </label>
            </span>
          </div>
        </section>

        <div class="btnArea sticky">
          <button type="button" class="btn_p" @click="goPaymentComplete()" :disabled="duplicatePayCheck">결제하기</button>
        </div>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>

    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
      <template v-slot:bottomButtom v-if="this.messageType == 'paymentComplete'">
        <button type="button" class="btn_p" @click="paymentPopClose">확인</button>
      </template>
    </MessagePop>
    <RentalPrePayDiscountVirtualSchedulePop
      v-if="rentalPrePayDiscountVirtualSchedulePop"
      :propsVirtualScheduleObj="virtualScheduleObj"
      @close="close"
    />
  </div>
  <!-- wrapper(e) -->
</template>

<style>
/* iptBtn */
.prePayTabList.iptBtn {
  display: flex;
  display: -webkit-flex;
  display: -ms-flexbox;
  width: calc(100% - 30px);
  box-sizing: border-box;
  margin-left: 15px;
  margin-right: 15px;
}
.prePayTabList.iptBtn > li {
  position: relative;
  width: 100%;
  padding: 11px 0 12px 0;
  color: #444;
  font-size: 1.4rem;
  letter-spacing: -0.05em;
  line-height: 1.5;
  background-color: #f5f5f5;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
  z-index: unset;
}
.prePayTabList.iptBtn > li:after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: -1px;
  right: 0;
  border: 1px solid #ccc;
  border-left: none;
}
.prePayTabList.iptBtn > li:first-child:after {
  left: 0;
  border-left: 1px solid #ccc;
  border-radius: 3px 0 0 3px;
}
.prePayTabList.iptBtn > li:last-child:after {
  border-radius: 0 3px 3px 0;
}
.prePayTabList.iptBtn > li.on {
  color: #ff4f0b;
  background-color: #fff;
}
.prePayTabList.iptBtn > li.on:after {
  border: 1px solid #ff4f0a !important;
  z-index: 2;
}
.prePayTabList.iptBtn > li.on span.ico {
  padding-left: 15px;
  background: url(../../../../../static/img/mw/common/ico_iptbtn_check.png) no-repeat left center;
  background-size: 12px auto !important;
}
.prePayTabList.iptBtn > li.on [class*='txt'] {
  color: #ff4f0b;
}

.tabWrap .prePayTabList.iptBtn {
  margin-bottom: 20px;
}
section:not(.full) .prePayTabList.iptBtn,
.orderBottom .prePayTabList.iptBtn {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}

.prePayTabList.iptBtn[class*='div_'] {
  position: relative;
  flex-wrap: wrap;
  padding-bottom: 1px;
}
.prePayTabList.iptBtn[class*='div_']:after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border: 1px solid #ccc;
  border-radius: 3px;
  background-color: #ccc;
  z-index: -1;
}
.prePayTabList.iptBtn[class*='div_'] > li {
  margin-bottom: -1px;
}
.prePayTabList.iptBtn[class*='div_'] > li:after {
  border-radius: 0;
  border-left: 1px solid #ccc;
}
.prePayTabList.iptBtn[class*='div_'] > li.brtl:after {
  border-radius: 3px 0 0 0;
}
.prePayTabList.iptBtn[class*='div_'] > li.brtr:after {
  border-radius: 0 3px 0 0;
}
.prePayTabList.iptBtn[class*='div_'] > li.brbl:after {
  border-radius: 0 0 0 3px;
}
.prePayTabList.iptBtn[class*='div_'] > li.brbr:after {
  border-radius: 0 0 3px 0;
}
.prePayTabList.iptBtn[class*='div_'] > li.brbl.brbr {
  width: 100% !important;
}
.prePayTabList.iptBtn.div_2 > li {
  width: 50%;
}
.prePayTabList.iptBtn.div_2 > li:nth-child(2n-1):after {
  left: 0;
}
.prePayTabList.iptBtn.div_3 > li {
  width: 33.3333%;
}
.prePayTabList.iptBtn.div_3 > li:nth-child(3n-2):after {
  left: 0;
}
</style>

<script>
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import RentalPrePayDiscountVirtualSchedulePop from '@/views/app/mypage/payment/RentalPrePayDiscountVirtualSchedulePop';
import { isEmpty } from '@/common/common.function';
import { OVERDUE_AMOUNT_CHECK } from '@/store/message.type';
import $ from 'jquery';

export default {
  name: 'RentalPrePayDiscount',
  data() {
    return {
      headerTitle: '렌탈료 선납할인',
      msg: null,
      messagePop: false,
      messageType: '',
      rentalPrePayDiscountVirtualSchedulePop: false,

      orderAuthBillSummaryList: [],
      summaryIdx: 99,
      orderId: '',
      payAmounts: 0, // 월렙탈료
      restRentalPeriod: 0, // 잔여회차
      startDate: '', // 선납 렌탈 기간 시작
      endDate: '', // 선납 렌탈 기간 끝
      startSeq: 0, // 선납 렌탈 기간 회차 시작
      endSeq: 0, // 선납 렌탈 기간 회차 끝
      reEndDate: '', // 재납부 예정일
      reEndSeq: 0, // 재납부 예정일 회차
      prePayAmounts: 0, // 선납 렌탈료
      prePaySale: 0, // 선납 할인
      prePaySaleAmounts: 0, // 선납 할인 금액
      exAmounts: 0, // 총 결제 예상금액
      remainingSeq: 0, // 잔여회차

      tabYear: null,
      showTabPanel: false,
      tabYear0: false,
      tabYear1: false,
      tabYear2: false,

      rcadCodeList: [], // 카드 리스트
      cardName: '',
      cardNumber: '',
      cardExpireDate: '',
      ssn: '',

      cardNum1: null,
      cardNum2: null,
      cardNum3: null,
      cardNum4: null,
      expirdateMM: null,
      expirdateYY: null,
      cardPasswd: '',
      ssn1: null,
      ssn2: null,
      ssn3: null,
      duplicatePayCheck: false, // 결제 중복 체크

      virtualScheduleObj: null,
      paymentRemained: true,

      payReduced: false,
    };
  },
  components: {
    MessagePop,
    RentalPrePayDiscountVirtualSchedulePop,
  },
  mounted() {
    this.selectOrderAuthBillSummary();
    this.selectCommonCodeList();
    if (process.env.NODE_ENV != 'dev') {
      import('@/raon/welcomeTranskey').then((m) => {
        m.importCSS();
        m.importJS(0, ['cardNum3', 'cardNum4', 'expirdateMM', 'expirdateYY', 'password']);
      });
    }
    //window.importCSS();
    //window.importJS(0, ['cardNum3', 'cardNum4', 'expirdateMM', 'expirdateYY', 'password']); // 보안키패드
  },
  methods: {
    selectOrderAuthBillSummary() {
      ApiService.service('GET', '/order/auth/bill/summary')
        .then(({ data }) => {
          let bizDate5 = data.result.bizDate5;
          for (let value of data.result.billInfoList) {
            if (value.nextAskDtm < bizDate5 && value.restRentalPeriod > 11) {
              this.orderAuthBillSummaryList.push(value);
            }
          }
          for (let i = 0; i < this.orderAuthBillSummaryList.length; i++) {
            if (this.orderAuthBillSummaryList[i].orderId === this.$route.params.orderId) {
              this.summaryIdx = i;
              break;
            }
          }
          this.changeOrderId();
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    selectCommonCodeList() {
      ApiService.service('GET', '/common/code/RCAD', '')
        .then(({ data }) => {
          for (let value of data.result) {
            if (value.codePrefix === 'RCAD') {
              this.rcadCodeList = value.codeList;
            }
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    showVirtualSchedule() {
      if (this.orderId === '') {
        this.msg = '상품을 선택해주세요.';
        this.messagePop = true;
        this.messageType = '';
      } else if (this.tabYear === null) {
        this.msg = '선납렌탈 기간을 선택해주세요.';
        this.messagePop = true;
        this.messageType = '';
      } else {
        this.virtualScheduleObj = {
          orderId: this.orderId,
          prePaidPeriod: (this.tabYear + 1) * 12,
        };

        this.rentalPrePayDiscountVirtualSchedulePop = true;
      }
    },
    validateByOrderId: function () {
      if (this.orderId === '') {
        this.msg = '상품을 선택해주세요.';
        this.messagePop = true;
        this.messageType = '';
        return false;
      }

      return true;
    },
    changeOrderId() {
      // console.log(this.summaryIdx);
      // console.log( this.orderAuthBillSummaryList[this.summaryIdx].ordrDivCd);

      // 22.04.22 김근유 대리님 요청건 ( 할부상품 노출관련 ) 
      // 하기 주석 해제
      // if ( this.orderAuthBillSummaryList[this.summaryIdx].ordrDivCd == 'RORT00IS'){
      //   this.orderId = ''; 
      //   this.summaryIdx = '99';
      //   this.msg = '할부상품은 렌탈료선납할인을 이용하실 수 없습니다.';
      //   this.messagePop = true;
      //   return false;
      // }
      if (this.summaryIdx == 99) {
        this.orderId = '';
      } else {
        this.orderId = this.orderAuthBillSummaryList[this.summaryIdx].orderId;
      }

      if (this.orderId === '') {
        this.tabYear = null;
        this.showTabPanel = false;

        this.restRentalPeriod = 0;
        this.payAmounts = 0;
        this.remainingSeq = 0;

        this.tabYear0 = false;
        this.tabYear1 = false;
        this.tabYear2 = false;
      } else {
        if (this.orderAuthBillSummaryList[this.summaryIdx].overdueAmounts * 1 > 0) {
          this.msg = OVERDUE_AMOUNT_CHECK;
          this.messagePop = true;
        } else {
          const fullYear = new Date().getFullYear();

          // 초기화 start
          // 잔여회차에 따른 선납렌탈 기간 선택 버튼 노출
          this.tabYear0 = false;
          this.tabYear1 = false;
          this.tabYear2 = false;
          if (this.orderAuthBillSummaryList[this.summaryIdx].restRentalPeriod >= 12) {
            this.tabYear0 = true;
          }
          if (this.orderAuthBillSummaryList[this.summaryIdx].restRentalPeriod >= 24) {
            this.tabYear1 = true;
          }
          if (this.orderAuthBillSummaryList[this.summaryIdx].restRentalPeriod >= 36) {
            this.tabYear2 = true;
          }

          $('.prePayTab > .prePayTabList > li').removeClass();
          this.showTabPanel = false;
          this.tabYear = null;
          this.remainingSeq = 0;
          // 초기화 end

          this.payAmounts = this.orderAuthBillSummaryList[this.summaryIdx].payAmounts;
          this.restRentalPeriod = this.orderAuthBillSummaryList[this.summaryIdx].restRentalPeriod;

          // 선납 시작일
          let nextDtm = this.orderAuthBillSummaryList[this.summaryIdx].nextAskDtm;
          let nextYear = nextDtm.substr(0, 4);
          let nextMonth = nextDtm.substr(4, 2);
          let nextDay = nextDtm.substr(6);

          this.startDate = nextYear + '.' + nextMonth + '.' + nextDay;

          // 선납 종료일
          let tempEndDate = new Date(nextYear, nextMonth * 1 - 1, nextDay);
          tempEndDate.setFullYear(tempEndDate.getFullYear() + (this.tabYear + 1));
          this.endDate = this.getFormatDate(tempEndDate);

          this.startSeq = this.orderAuthBillSummaryList[this.summaryIdx].seq;

          this.endSeq = this.startSeq * 1 + (this.tabYear * 1 + 1) * 12 - 1;

          tempEndDate.setMonth(tempEndDate.getMonth() + 1);
          this.reEndDate = this.getFormatDate(tempEndDate);
          this.reEndSeq = this.endSeq + 1;
          this.prePayAmounts = this.payAmounts * ((this.tabYear + 1) * 12);
          if (this.tabYear === 0) {
            this.prePaySale = 6;
            this.prePaySaleAmounts = this.prePayAmounts * 0.06;
          } else if (this.tabYear === 1) {
            this.prePaySale = 8;
            this.prePaySaleAmounts = this.prePayAmounts * 0.08;
          } else if (this.tabYear === 2) {
            this.prePaySale = 10;
            this.prePaySaleAmounts = this.prePayAmounts * 0.1;
          }

          this.exAmounts = this.prePayAmounts - this.prePaySaleAmounts;
          if (this.tabYear != null) {
            this.remainingSeq = this.orderAuthBillSummaryList[this.summaryIdx].restRentalPeriod - (this.tabYear + 1) * 12;
            this.paymentRemained = true;
          } else {
            this.remainingSeq = 0;
            this.paymentRemained = false;
          }
        }
      }
    },
    choiceYear(idx) {
      if (!this.validateByOrderId()) {
        return false;
      }

      this.tabYear = idx;

      const fullYear = new Date().getFullYear();

      this.payAmounts = this.orderAuthBillSummaryList[this.summaryIdx].payAmounts;
      this.restRentalPeriod = this.orderAuthBillSummaryList[this.summaryIdx].restRentalPeriod;

      // 선납 시작일
      let nextDtm = this.orderAuthBillSummaryList[this.summaryIdx].nextAskDtm;
      let nextYear = nextDtm.substr(0, 4);
      let nextMonth = nextDtm.substr(4, 2);
      let nextDay = nextDtm.substr(6);

      this.startDate = nextYear + '.' + nextMonth + '.' + nextDay;

      // 선납 종료일
      let tempEndDate = new Date(nextYear, nextMonth * 1 - 1, nextDay);

      tempEndDate.setFullYear(tempEndDate.getFullYear() + (this.tabYear + 1));
      tempEndDate.setMonth(tempEndDate.getMonth() - 1);

      this.endDate = this.getFormatDate(tempEndDate);

      ApiService.service(
        'GET',
        '/order/auth/bill/reduction/' + this.orderId + '/from/' + this.startDate.replace(/\./g, '') + '/to/' + this.endDate.replace(/\./g, ''),
      )
        .then(({ data }) => {
          if (data.result != null && data.result != '' && data.result.length > 0) {
            this.msg = `선납스케줄 확인이 필요합니다.<br>고객센터(1670-0202) 로 연락 부탁드립니다.`;
            this.messagePop = true;
            this.messageType = '';
            this.payReduced = true;

            return false;
          } else {
            this.payReduced = false;

            this.startSeq = this.orderAuthBillSummaryList[this.summaryIdx].seq;
            this.endSeq = this.startSeq * 1 + (this.tabYear * 1 + 1) * 12 - 1;
            tempEndDate.setMonth(tempEndDate.getMonth() + 1);
            this.reEndDate = this.getFormatDate(tempEndDate);
            this.reEndSeq = this.endSeq + 1;
            this.prePayAmounts = this.payAmounts * ((this.tabYear + 1) * 12);
            if (this.tabYear === 0) {
              this.prePaySale = 6;
              this.prePaySaleAmounts = this.prePayAmounts * 0.06;
            } else if (this.tabYear === 1) {
              this.prePaySale = 8;
              this.prePaySaleAmounts = this.prePayAmounts * 0.08;
            } else if (this.tabYear === 2) {
              this.prePaySale = 10;
              this.prePaySaleAmounts = this.prePayAmounts * 0.1;
            }
            this.exAmounts = this.prePayAmounts - this.prePaySaleAmounts;
            this.remainingSeq = this.orderAuthBillSummaryList[this.summaryIdx].restRentalPeriod - (this.tabYear + 1) * 12;
            if (this.remainingSeq > 0) {
              this.paymentRemained = true;
            } else {
              this.paymentRemained = false;
            }

            this.showTabPanel = true;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    getFormatDate(date) {
      const year = date.getFullYear();
      let month = 1 + date.getMonth();
      month = month >= 10 ? month : '0' + month;
      let day = date.getDate();
      day = day >= 10 ? day : '0' + day;
      return year + '.' + month + '.' + day;
    },
    changeCard: function (value) {
      this.cardName = value;
    },
    validate: function () {
      if (this.orderId === '') {
        this.msg = '상품을 선택해주세요.';
        this.messagePop = true;
        this.messageType = '';
        return false;
      }
      if (this.tabYear === null) {
        this.msg = '선납렌탈 기간을 선택해주세요.';
        this.messagePop = true;
        this.messageType = '';
        return false;
      }
      if (this.payReduced) {
        this.msg = `선납스케줄 확인이 필요합니다.<br>고객센터(1670-0202) 로 연락 부탁드립니다.`;
        this.messagePop = true;
        this.messageType = '';
        return false;
      }
      if (isEmpty(this.cardName)) {
        this.msg = '카드를 선택해주세요.';
        this.messagePop = true;
        this.messageType = '';
        return false;
      }
      if (isEmpty(this.cardNum1) || isEmpty(this.cardNum2)) {
        this.msg = '카드번호를 입력해주세요.';
        this.messagePop = true;
        this.messageType = '';
        return false;
      }
      /* TODO : 암호화 필드 유효성 검사
        if (isEmpty(this.expirdateMM) || isEmpty(this.expirdateYY)) {
          this.msg = '유효기간을 입력해주세요.';
          this.messagePop = true;
          this.messageType = '';
          return false;
        }
        if (isEmpty(this.cardPasswd)) {
          this.msg = '비밀번호를 입력해주세요.';
          this.messagePop = true;
          this.messageType = '';
          return false;
        }*/
      if (isEmpty(this.ssn1) || isEmpty(this.ssn2) || isEmpty(this.ssn3)) {
        this.msg = '생년월일을 입력해주세요.';
        this.messagePop = true;
        this.messageType = '';
        return false;
      }

      const chk2 = document.getElementById('chk2').checked;

      if (!chk2) {
        this.msg = '필수 동의 사항에 체크해주세요';
        this.messagePop = true;
        this.messageType = '';
        return false;
      }

      return true;
    },
    goPaymentComplete() {
      if (this.duplicatePayCheck) {
        // 중복 결제 체크로직
        return;
      }
      if (!this.validate()) {
        return;
      }
      this.duplicatePayCheck = true;

      this.cardNumber = this.cardNum1 + '-' + this.cardNum2 + '-' + this.cardNum3 + '-' + this.cardNum4;
      this.cardExpireDate = this.expirdateMM + '-' + this.expirdateYY;
      this.ssn = this.ssn1 + '' + this.ssn2 + '' + this.ssn3;

      let prePaidPeriodCode = '';
      if (this.tabYear === 0) {
        prePaidPeriodCode = 'RSTN0001';
      } else if (this.tabYear === 1) {
        prePaidPeriodCode = 'RSTN0002';
      } else if (this.tabYear === 2) {
        prePaidPeriodCode = 'RSTN0003';
      }

      let reqParam = {};
      if (process.env.NODE_ENV == 'dev') {
        reqParam = {
          request: {
            orderId: this.orderId,
            payInfo: {
              birth: this.ssn,
              cardCode: this.cardName,
              cardNumber1: this.cardNum1,
              cardNumber2: this.cardNum2,
              cardNumber3: document.getElementById('cardNum3').value,
              cardNumber4: document.getElementById('cardNum4').value,
              cardExpireYY: document.getElementById('expirdateYY').value,
              cardExpireMM: document.getElementById('expirdateMM').value,
              cardNumber: this.cardNumber,
              monthInstPlan: 0,
              passwd: this.cardPasswd,
              price: this.exAmounts,
            },
            prePaidPeriodCode: prePaidPeriodCode,
          },
          serviceType: '',
        };
      } else {
        reqParam = {
          request: {
            orderId: this.orderId,
            payInfo: {
              birth: this.ssn,
              cardCode: this.cardName,
              cardNumber1: this.cardNum1,
              cardNumber2: this.cardNum2,
              encCardNumber3: this.makeData('cardNum3', 'Y'),
              encCardNumber4: this.makeData('cardNum4', 'Y'),
              encCardExpireMM: this.makeData('expirdateMM', 'Y'),
              encCardExpireYY: this.makeData('expirdateYY', 'Y'),
              cardNumber: this.cardNumber,
              monthInstPlan: 0,
              passwd: this.cardPasswd,
              encPasswd: this.makeData('password', 'Y'),
              price: this.exAmounts,
            },
            prePaidPeriodCode: prePaidPeriodCode,
          },
          serviceType: '',
        };
      }

      this.$refs.header.loadingStart();
      ApiService.service('POST', 'order/auth/prepayments/discount', reqParam)
        .then((response) => {
          console.log(response);
          if (response.data.isSucceed) {
            const params = {
              af_order_id: reqParam.request.orderId,
            };
            //const appsFlyerParams = JSON.stringify(params);
            window.appsFlyer('af_rentalprepay_pay', params);
            this.msg = '결제 완료되었습니다.';
            this.messagePop = true;
            this.messageType = 'paymentComplete';
          } else {
            if (response.data.result != null) {
              this.msg = response.data.result.resultMessage;
            } else {
              this.msg = response.data.error;
            }
            this.messagePop = true;
            this.messageType = '';
          }
        })
        .catch((response) => {
          console.log(response);
        })
        .finally(() => {
          this.$refs.header.loadingEnd();
        });
    },
    close() {
      this.messagePop = false;
      this.messageType = '';
      this.rentalPrePayDiscountVirtualSchedulePop = false;
    },
    paymentPopClose() {
      this.messagePop = false;
      this.$router.go(-1);
    },
    makeData(id, encrytedYN, plainValue) {
      if (process.env.NODE_ENV == 'dev') return null;

      // eslint-disable-next-line no-undef
      let values = mtk.inputFillEncData(document.getElementById(id));
      let name = document.getElementById(id).name;
      let hidden = values.hidden;
      let hmac = values.hmac;

      // eslint-disable-next-line no-undef
      let keyboardType = transkey[id].keyboard;
      // eslint-disable-next-line no-undef
      let keyIndex = transkey[id].keyIndex;
      // eslint-disable-next-line no-undef
      let fieldType = transkey[id].fieldType;
      let seedKey = document.getElementById('seedKey').value;
      let initTime = document.getElementById('initTime').value;
      let ExE2E = values.ExE2E;

      let newRaonRequest = {};
      newRaonRequest.id = id;
      newRaonRequest.name = name;
      newRaonRequest.keyboardType = keyboardType;
      newRaonRequest.keyIndex = keyIndex;
      newRaonRequest.fieldType = fieldType;
      newRaonRequest.seedKey = seedKey;
      newRaonRequest.initTime = initTime;
      newRaonRequest.transkey = hidden;
      newRaonRequest.transkey_HM = hmac.toString();
      newRaonRequest.transkey_EXE2E = ExE2E;
      newRaonRequest.plainValue = plainValue;
      newRaonRequest.encrytedYN = encrytedYN;

      return newRaonRequest;
    },
  },
};
</script>
